import { render, staticRenderFns } from "./AdminMissionUserRights.vue?vue&type=template&id=710d8c16"
import script from "./AdminMissionUserRights.vue?vue&type=script&lang=ts"
export * from "./AdminMissionUserRights.vue?vue&type=script&lang=ts"
import style0 from "./AdminMissionUserRights.vue?vue&type=style&index=0&id=710d8c16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports